var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0707 17.6669C20.5839 17.6669 21 17.2509 21 16.7376C21 16.2244 20.5839 15.8083 20.0707 15.8083H3.9293C3.41606 15.8083 3 16.2244 3 16.7376C3 17.2509 3.41606 17.6669 3.9293 17.6669H20.0707ZM20.0707 13.0204C20.5839 13.0204 21 12.6044 21 12.0911C21 11.5779 20.5839 11.1618 20.0707 11.1618H3.9293C3.41606 11.1618 3 11.5779 3 12.0911C3 12.6044 3.41606 13.0204 3.9293 13.0204H20.0707ZM3 7.44462C3 7.95786 3.41606 8.37392 3.9293 8.37392H20.0707C20.5839 8.37392 21 7.95786 21 7.44462C21 6.93138 20.5839 6.51532 20.0707 6.51532H3.9293C3.41606 6.51532 3 6.93138 3 7.44462Z",
    fill: "#FDE5F1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 18,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0707 17.6669C20.5839 17.6669 21 17.2509 21 16.7376C21 16.2244 20.5839 15.8083 20.0707 15.8083H3.9293C3.41606 15.8083 3 16.2244 3 16.7376C3 17.2509 3.41606 17.6669 3.9293 17.6669H20.0707ZM20.0707 13.0204C20.5839 13.0204 21 12.6044 21 12.0911C21 11.5779 20.5839 11.1618 20.0707 11.1618H3.9293C3.41606 11.1618 3 11.5779 3 12.0911C3 12.6044 3.41606 13.0204 3.9293 13.0204H20.0707ZM3 7.44462C3 7.95786 3.41606 8.37392 3.9293 8.37392H20.0707C20.5839 8.37392 21 7.95786 21 7.44462C21 6.93138 20.5839 6.51532 20.0707 6.51532H3.9293C3.41606 6.51532 3 6.93138 3 7.44462Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.939514,
    width: 24,
    height: 22.3032,
    fill: "#303336"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5908f321.svg";
export { ForwardRef as ReactComponent };